import { gridConfig, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getContactDetailFormWidgetStyles = (breakpoint, isLargeScreen) => {
  var _a, _b, _c, _d;
  var columnSpacing = (_c = (_b = (_a = gridConfig === null || gridConfig === void 0 ? void 0 : gridConfig.light) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b[breakpoint]) === null || _c === void 0 ? void 0 : _c.columnSpacing;
  var colGutter = (_d = tokens.spacing) === null || _d === void 0 ? void 0 : _d[columnSpacing];
  var spacingToken = tokens.spacing;
  return StyleSheet.create({
    topPadding: {
      paddingTop: isLargeScreen ? colGutter : colGutter - 4
    },
    buttonPadding: {
      paddingTop: spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_20
    }
  });
};